import { v4 as uuidv4 } from 'uuid'

interface Props {
  [key: string]: any
}

export default function HomChatAddIcon(props: Props): React.ReactElement {
  const { pathClassName, ...rest } = props
  const uuid = uuidv4()
  return (
    <svg fill="none" viewBox="0 0 29 29" {...rest} xmlns="http://www.w3.org/2000/svg">
      <path
        d="M15.1905 0C7.56348 0 1.38096 6.14743 1.38096 13.7311C1.38096 16.2281 2.06177 18.5624 3.23282 20.5795L0.0814825 27.7088C-0.267898 28.499 0.572411 29.2878 1.34574 28.8965L8.08065 25.4864C10.1597 26.7325 12.5867 27.4623 15.1905 27.4623C22.8175 27.4623 29 21.3148 29 13.7311C29 6.14743 22.8175 0 15.1905 0Z"
        fill={`url(#${uuid}paint0_linear)`}
      />
      <path
        d="M20.56 14.8744H16.9572V18.56H13.6028V14.8744H10V11.7064H13.6028V8H16.9572V11.7064H20.56V14.8744Z"
        fill="white"
      />
      <defs>
        <linearGradient
          gradientUnits="userSpaceOnUse"
          id={`${uuid}paint0_linear`}
          x1="22.2347"
          x2="5.62926"
          y1="1.91824"
          y2="30.0841"
        >
          <stop stopColor="#7D38D6" />
          <stop offset="1" stopColor="#B076BF" />
        </linearGradient>
      </defs>
    </svg>
  )
}
